import { ReactElement } from 'react';
import { EmulatorType } from '@localstack/types';
import { Theme } from '@mui/material';
import { EmulatorIcon } from '@localstack/ui';
import { THIRTY_DAY_TRIAL_DURATION } from '@localstack/constants';

import { PlanChoice } from './types';

type EmulatorOption = {
  value: EmulatorType;
  headingColor: (theme: Theme) => string;
  icon: ReactElement;
  /**
   * The plans this emulator can run on, and the terms shown once it is picked.
   * A plan left out is unavailable, e.g. Snowflake has no free tier, so every
   * listed plan needs non-empty terms.
   */
  termsByPlan: Partial<Record<PlanChoice, string>>;
};

export const emulatorOptions: EmulatorOption[] = [
  {
    value: EmulatorType.AWS,
    headingColor: (theme: Theme): string => theme.palette.aws.text,
    icon: <EmulatorIcon emulator={EmulatorType.AWS} />,
    termsByPlan: {
      [PlanChoice.FREE]: 'Use LocalStack for AWS free for non-commercial projects. No credit card required.',
      [PlanChoice.TRIAL]: `Start a ${THIRTY_DAY_TRIAL_DURATION}-day free trial of our LocalStack for AWS Ultimate License. No credit card required.`,
    },
  },
  {
    value: EmulatorType.SNOWFLAKE,
    headingColor: (theme: Theme): string => theme.palette.snowflake.text,
    icon: <EmulatorIcon emulator={EmulatorType.SNOWFLAKE} />,
    termsByPlan: {
      [PlanChoice.TRIAL]: `Start a free ${THIRTY_DAY_TRIAL_DURATION}-day trial of our LocalStack for Snowflake Base License. No credit card required.`,
    },
  },
  {
    value: EmulatorType.AZURE,
    headingColor: (theme: Theme): string => theme.palette.azure.text,
    icon: <EmulatorIcon emulator={EmulatorType.AZURE} />,
    // Preview rather than trial: it runs open-ended, so no trial length applies.
    termsByPlan: {
      [PlanChoice.PREVIEW]: 'Join the LocalStack for Azure Public Preview. No credit card required.',
    },
  },
];
